// src/components/RecentVideos.jsx
import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { getChannelRecentVideos } from '../api/youtubeApi';

function RecentVideos({ lang = 'ko', channelId = 'UC8LmJGfDvbwbofuAYzUYiJA' }) {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadVideos = async () => {
      try {
        setLoading(true);
        setError(null);

        const items = await getChannelRecentVideos(channelId, 4);
        setVideos(items || []);
      } catch (err) {
        console.error('Error fetching videos:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    loadVideos();
  }, [channelId]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[200px]">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (error || videos.length === 0) {
    return (
      <div className="text-center py-8">
        <h2 className="text-xl font-bold text-gray-700 mb-2">
          {lang === 'ko' ? '최근 예배 영상' : 'Recent Services'}
        </h2>
        <p className="text-gray-600">
          {lang === 'ko'
            ? '새로운 예배 영상이 곧 업로드될 예정입니다.'
            : 'New service videos will be uploaded soon.'}
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {videos.map((video, index) => (
        <motion.div
          key={video.id.videoId || index}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
          className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
        >
          <a
            href={`https://www.youtube.com/watch?v=${video.id.videoId}`}
            target="_blank"
            rel="noopener noreferrer"
            className="block"
          >
            <div className="aspect-video relative group">
              <img
                src={video.snippet?.thumbnails?.medium?.url}
                alt={video.snippet?.title || 'No Title'}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <span className="text-white text-lg font-bold">
                  {lang === 'ko' ? '▶ 재생하기' : '▶ Play'}
                </span>
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-sm font-medium text-gray-900 line-clamp-2">
                {video.snippet?.title}
              </h3>
            </div>
          </a>
        </motion.div>
      ))}
    </div>
  );
}

export default RecentVideos;